module.exports = __webpack_public_path__ + "img/283.ec074656.png";